const newsCardReferenzTemplate = document.createElement('template')

newsCardReferenzTemplate.innerHTML = `
<div class="featured-news news-element">
  <picture class="img-fluid masonry-image">
    <img class="image-blur image-embed-item img-fluid w-100" title=""
      alt="" src=""
      width="100%" height="100%" loading="lazy" />
  </picture>
  <div class="top-left badge"></div>
  <div class="top-left subline masonary-content">
    <h4 class="news-title"></h4>
  </div>
  <a class="color-text small stretched-link"
    title=""></a>
  </n:link>
</div>
`

class NewsCardReferenz extends HTMLElement {
  constructor(categories: string, image: string, link: string, title: string) {
    super()
    this.appendChild(newsCardReferenzTemplate.content.cloneNode(true))
    this.classList.add('col-xxl-3', 'news-col', 'news-col-featured')
    const currentSlug = window.location.pathname.split('/')[1]
    const badge = this.querySelector('.badge') as HTMLElement
    const img = this.querySelector('.masonry-image img') as HTMLImageElement
    const titleElement = this.querySelector('.news-title') as HTMLElement
    const linkElement = this.querySelector(
      '.stretched-link'
    ) as HTMLAnchorElement
    badge
      ? (badge.innerText = this.getAttribute('categories') || categories)
      : null

    img ? (img.src = this.getAttribute('image') || image) : null
    titleElement
      ? (titleElement.innerText = this.getAttribute('title') || title)
      : null
    linkElement
      ? (linkElement.href =
          this.getAttribute('link') || currentSlug === 'de'
            ? '/de/expertise/artikel/' + link
            : '/en/expertise/article/' + link)
      : null
    linkElement
      ? (linkElement.title = this.getAttribute('title') || title)
      : null
  }
  connectedCallback() {
    this.render()
  }

  render() {}
}

export default NewsCardReferenz
